import React from "react";

import Header from '../../header';
import Footer from '../../footer';
import ApplicationFormAutumn from '../../components/forms/ApplicationFormAutumn';
import PhotoGallery from '../../components/PhotoGallery';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';

import {getCampIntroduction, loadCampsDataAndRender, loadPhotoGalleryImages, getPhotosFromGallery} from './CampsUtil';


const eventName = "Brno-Bohunice";

export default class AutumnCamps extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photoUrl: undefined,
      campsData: [],
      photoGallery: [],
      isLoading: true
    };
  }

  componentDidMount(){
      loadCampsDataAndRender("autumn_camps", this);
      loadPhotoGalleryImages("goalkeepers_day_camps", eventName, this);
  }

  render() {
    const {campsData, isLoading, isIntroLoading, photoUrl, photoGallery} = this.state;
    const hideHeaderAndFooter = this.props.hideHeaderAndFooter;
    let campIntroduction = undefined;
    let isPhotoGalleryLoading = true;

    if(campsData.length > 0) {
      campIntroduction = campsData[0];
      let numberOfGalleriesToLoad = campIntroduction.number_of_galleries !== undefined ? campIntroduction.number_of_galleries : 0;
      isPhotoGalleryLoading = (photoGallery.length < numberOfGalleriesToLoad);
      console.log("Number of photoGallery to load: " + numberOfGalleriesToLoad);
      console.log("Loaded photoGalleries: " + photoGallery.length);
    }

    let loading = isLoading || isIntroLoading || isPhotoGalleryLoading

    return loading ? (
            <LoadingSpinner loadingState={loading} />
        ) : (
      <div>
            {hideHeaderAndFooter ? '' : <Header />}

            <div class="view textArticle camps">
                <div className="left">
                  {getCampIntroduction(campIntroduction, photoUrl)}

                    <p>
                      <h4> klikni pro přihlášku na: </h4>                      
                      <h4> <a href='https://just4keepers.dtap.cz/register/?link=31'>29.10. Brno - Bohunice</a></h4>
                    </p>
                  <p>
                    Více informací na tel. 731 575 400 nebo na just4keeperscz@gmail.com
                  </p>

                </div>



                <PhotoGallery photos={getPhotosFromGallery(eventName, photoGallery)}/>


            </div>

            {hideHeaderAndFooter ? '' : <Footer />}
      </div>
    );
  }

}
